<template>
  <div class="roulette-component select-none" id="racetrack-component">
    <div class="racetrack-wrapper w-full flex justify-center items-center py-2">
      <div
        class="roulette-racetrack-v2 w-full max-w-[760px]"
        id="rouletteTrackv2"
      >
        <svg
          viewBox="75 8 650 164"
          preserveAspectRatio="xMidYMid meet"
          class="racetrack-svg"
          xmlns="http://www.w3.org/2000/svg"
          style="width: 100%; height: auto; display: block"
        >
          <defs>
            <!-- Radial gradient for inner sectors (Zero Spiel, Voisins, Orphelins, Tiers) -->
            <radialGradient
              id="sectorClothGrad"
              cx="50%"
              cy="50%"
              r="60%"
              fx="50%"
              fy="50%"
            >
              <stop offset="0%" stop-color="#063d30" />
              <stop offset="100%" stop-color="#022019" />
            </radialGradient>

            <!-- Drop shadow for chips -->
            <filter
              id="racetrackChipShadow"
              x="-30%"
              y="-30%"
              width="160%"
              height="160%"
            >
              <feDropShadow
                dx="0"
                dy="1.5"
                stdDeviation="1.5"
                flood-opacity="0.45"
              />
            </filter>
          </defs>

          <!-- ── ZONE INTERNE (renderizzate per prime = sotto i numeri) ── -->
          <g class="inner-board-group">
            <!-- 1. VOISINS (type_id 159) -->
            <path
              :d="`M 160 40 L ${x_fine_25} 40 L ${x_fine_22} 140 L 160 140 A 50 50 0 0 1 160 40 Z`"
              :class="[
                'svg-zone --voisins',
                isZoneActive('voisins') ? '--active' : '',
              ]"
              data-bet-id="serie::voisins"
            />

            <!-- 2. ORPHELINS (type_id 160) -->
            <path
              :d="`M ${x_fine_25} 40 L ${x_fine_6} 40 L ${x_fine_1} 140 L ${x_fine_22} 140 Z`"
              :class="[
                'svg-zone --orphelins',
                isZoneActive('orphelins') ? '--active' : '',
              ]"
              data-bet-id="serie::orphelins"
            />

            <!-- 3. TIERS (type_id 161) -->
            <path
              :d="`M ${x_fine_6} 40 L 640 40 A 50 50 0 0 1 640 140 L ${x_fine_1} 140 Z`"
              :class="[
                'svg-zone --tiers',
                isZoneActive('tiers') ? '--active' : '',
              ]"
              data-bet-id="serie::tiers"
            />

            <!-- 4. JEU ZERO / 0-GAME (type_id 158) -->
            <path
              :d="`M ${x_fine_15} 40 L 160 40 A 50 50 0 0 0 160 140 L ${x_fine_15} 140 A 50 50 0 0 0 ${x_fine_15} 40 Z`"
              :class="[
                'svg-zone --game-0',
                isZoneActive('game-0') ? '--active' : '',
              ]"
              data-bet-id="serie::jeu_zero"
            />
          </g>

          <!-- ── TESTI DELLE ZONE INTERNE ── -->
          <g class="inner-texts-group" pointer-events="none">
            <text
              :x="(160 + x_fine_15) / 2 - 10"
              y="94"
              class="svg-zone-text"
              text-anchor="middle"
              style="
                font-weight: bold;
                font-size: 11px;
                text-transform: uppercase;
              "
            >
              Jeu Zéro
            </text>
            <text
              :x="(x_fine_15 + x_fine_25) / 2 + 10"
              y="94"
              class="svg-zone-text"
              text-anchor="middle"
            >
              VOISINS
            </text>
            <text
              :x="(x_fine_25 + x_fine_6) / 2"
              y="94"
              class="svg-zone-text"
              text-anchor="middle"
            >
              ORPHELINS
            </text>
            <text x="580" y="94" class="svg-zone-text" text-anchor="middle">
              TIERS
            </text>
          </g>

          <!-- ── NUMERI (renderizzati per ultimi = sopra le zone) ── -->
          <g class="numbers-track-group">
            <g
              v-for="cell in svgCells"
              :key="cell.num"
              :data-bet-id="`straight::${cell.num}`"
              :class="[
                'svg-cell-group',
                `--${cell.type}`,
                cell.isCovered ? '--highlighted' : '',
                cell.hasBet ? '--has-bet' : '',
              ]"
            >
              <!-- Hit-area -->
              <circle
                :cx="cell.tx"
                :cy="cell.ty - 3"
                r="14"
                fill="transparent"
                stroke="none"
              />
              <path :d="cell.d" class="svg-cell-path" />
              <text
                :x="cell.tx"
                :y="cell.ty"
                text-anchor="middle"
                class="svg-cell-text"
                style="font-size: 12px; font-weight: 600"
              >
                {{ cell.num }}
              </text>

              <!-- Chip su singolo numero (se presente puntata diretta) -->
              <g
                v-if="cell.hasBet && cell.chipAmount"
                class="racetrack-chip"
                :transform="`translate(${cell.tx}, ${
                  cell.ty < 50 ? cell.ty - 1 : cell.ty - 4
                })`"
              >
                <circle
                  cx="0"
                  cy="0"
                  r="10"
                  class="chip-base"
                  filter="url(#racetrackChipShadow)"
                />
                <circle cx="0" cy="0" r="8" class="chip-ring" />
                <text y="3.5" text-anchor="middle" class="chip-label">
                  {{ cell.chipAmount }}
                </text>
              </g>

              <!-- Cerchio sul numero estratto se disponibile -->
              <circle
                v-if="isWinningNumber(cell.num)"
                :cx="cell.tx"
                :cy="cell.ty - 3"
                r="13"
                class="winning-ring-svg"
                fill="none"
                stroke="#facc15"
                stroke-width="2.5"
                pointer-events="none"
              />
            </g>
          </g>

          <!-- ── CHIPS OVERLAY SULLE SERIE / ZONE ── -->
          <g class="racetrack-chips-overlay" pointer-events="none">
            <!-- 1. ZERO GAME -->
            <g
              v-if="getSectorChipAmount('game-0')"
              class="racetrack-chip"
              :transform="`translate(${(160 + x_fine_15) / 2 - 10}, 74)`"
            >
              <circle
                cx="0"
                cy="0"
                r="11"
                class="chip-base chip-sector"
                filter="url(#racetrackChipShadow)"
              />
              <circle cx="0" cy="0" r="9" class="chip-ring" />
              <text y="3.5" text-anchor="middle" class="chip-label">
                {{ getSectorChipAmount("game-0") }}
              </text>
            </g>

            <!-- 2. VOISINS -->
            <g
              v-if="getSectorChipAmount('voisins')"
              class="racetrack-chip"
              :transform="`translate(${(x_fine_15 + x_fine_25) / 2 + 10}, 74)`"
            >
              <circle
                cx="0"
                cy="0"
                r="11"
                class="chip-base chip-sector"
                filter="url(#racetrackChipShadow)"
              />
              <circle cx="0" cy="0" r="9" class="chip-ring" />
              <text y="3.5" text-anchor="middle" class="chip-label">
                {{ getSectorChipAmount("voisins") }}
              </text>
            </g>

            <!-- 3. ORPHELINS -->
            <g
              v-if="getSectorChipAmount('orphelins')"
              class="racetrack-chip"
              :transform="`translate(${(x_fine_25 + x_fine_6) / 2}, 74)`"
            >
              <circle
                cx="0"
                cy="0"
                r="11"
                class="chip-base chip-sector"
                filter="url(#racetrackChipShadow)"
              />
              <circle cx="0" cy="0" r="9" class="chip-ring" />
              <text y="3.5" text-anchor="middle" class="chip-label">
                {{ getSectorChipAmount("orphelins") }}
              </text>
            </g>

            <!-- 4. TIERS -->
            <g
              v-if="getSectorChipAmount('tiers')"
              class="racetrack-chip"
              :transform="`translate(580, 74)`"
            >
              <circle
                cx="0"
                cy="0"
                r="11"
                class="chip-base chip-sector"
                filter="url(#racetrackChipShadow)"
              />
              <circle cx="0" cy="0" r="9" class="chip-ring" />
              <text y="3.5" text-anchor="middle" class="chip-label">
                {{ getSectorChipAmount("tiers") }}
              </text>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import rouletteBetTypes from "../config/rouletteBetTypes.json";

const props = defineProps({
  bets: {
    type: Array,
    default: () => [],
  },
  currentSlideIndex: {
    type: [Number, String],
    default: "all",
  },
  currency: {
    type: String,
    default: "EUR",
  },
  winningNumber: {
    type: Number,
    default: null,
  },
});

// Official European Roulette Wheel sequence
const wheelOrder = [
  0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24,
  16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26,
];

const zoneTypeIds = {
  "game-0": 158, // Jeu Zéro
  voisins: 159, // Voisins du Zéro
  orphelins: 160, // Orphelins
  tiers: 161, // Tiers du Cylindre
};

const isAllMode = computed(() => props.currentSlideIndex === "all");

const activeBets = computed(() => {
  if (!props.bets || props.bets.length === 0) return [];
  if (isAllMode.value) return props.bets;
  const idx = Number(props.currentSlideIndex);
  return props.bets[idx] ? [props.bets[idx]] : [];
});

const coveredNumbersSet = computed(() => {
  const set = new Set();
  for (const bet of activeBets.value) {
    const typeIdStr = String(bet.type_id);
    const info = rouletteBetTypes[typeIdStr];
    if (info && info.numbers) {
      info.numbers.forEach((n) => set.add(n));
    }
  }
  return set;
});

function getNumberType(num) {
  if (num === 0) return "green";
  const reds = [
    32, 19, 21, 25, 34, 27, 36, 30, 23, 5, 16, 1, 14, 9, 18, 7, 12, 3,
  ];
  return reds.includes(num) ? "red" : "black";
}

function formatChipLabel(amt) {
  if (amt == null || amt <= 0) return "";
  return parseFloat(amt).toFixed(2);
}

function isWinningNumber(num) {
  if (
    props.winningNumber === null ||
    props.winningNumber === undefined ||
    props.winningNumber === ""
  ) {
    return false;
  }
  return Number(props.winningNumber) === Number(num);
}

function isZoneActive(zone) {
  const targetTypeId = zoneTypeIds[zone];
  return activeBets.value.some(
    (b) => Number(b.type_id) === Number(targetTypeId),
  );
}

function getSectorChipAmount(zone) {
  const targetTypeId = zoneTypeIds[zone];
  const sum = activeBets.value
    .filter((b) => Number(b.type_id) === Number(targetTypeId))
    .reduce((acc, b) => acc + (parseFloat(b.amount) || 0), 0);
  return sum > 0 ? formatChipLabel(sum) : null;
}

// ── Geometria esatta del racetrack da cyberautoroulette ──
const X_L = 160;
const X_R = 640;
const Y_C = 90;
const R_out = 80;
const R_in = 50;
const w = (X_R - X_L) / 13; // 480 / 13

const x_fine_15 = 145 + 1 * w;
const x_fine_25 = 160 + 6 * w;
const x_fine_6 = 160 + 9 * w;
const x_fine_22 = x_fine_25;
const x_fine_1 = 160 + 11 * w;

const svgCells = computed(() => {
  const cells = [];

  wheelOrder.forEach((num, i) => {
    let d = "";
    let tx = 0;
    let ty = 0;

    if (i >= 2 && i <= 14) {
      // Straight top (13 pockets from 15 to 36)
      const k = i - 2;
      const x1 = X_L + k * w;
      const x2 = X_L + (k + 1) * w;
      d = `M ${x1} 10 L ${x2} 10 L ${x2} 40 L ${x1} 40 Z`;
      tx = (x1 + x2) / 2;
      ty = 26;
    } else if (i >= 15 && i <= 20) {
      // Right semicircle (6 pockets from 11 to 5)
      const k = i - 15;
      const da = Math.PI / 6;
      const a1 = -Math.PI / 2 + k * da;
      const a2 = a1 + da;
      const xo1 = X_R + R_out * Math.cos(a1);
      const yo1 = Y_C + R_out * Math.sin(a1);
      const xo2 = X_R + R_out * Math.cos(a2);
      const yo2 = Y_C + R_out * Math.sin(a2);
      const xi1 = X_R + R_in * Math.cos(a1);
      const yi1 = Y_C + R_in * Math.sin(a1);
      const xi2 = X_R + R_in * Math.cos(a2);
      const yi2 = Y_C + R_in * Math.sin(a2);
      d = `M ${xo1} ${yo1} A ${R_out} ${R_out} 0 0 1 ${xo2} ${yo2} L ${xi2} ${yi2} A ${R_in} ${R_in} 0 0 0 ${xi1} ${yi1} Z`;
      const am = (a1 + a2) / 2;
      const rm = (R_out + R_in) / 2;
      tx = X_R + rm * Math.cos(am);
      ty = Y_C + rm * Math.sin(am) + 4;
    } else if (i >= 21 && i <= 33) {
      // Straight bottom (13 pockets from 24 to 28)
      const k = i - 21;
      const x1 = X_R - k * w;
      const x2 = X_R - (k + 1) * w;
      d = `M ${x1} 170 L ${x2} 170 L ${x2} 140 L ${x1} 140 Z`;
      tx = (x1 + x2) / 2;
      ty = 159;
    } else {
      // Left semicircle (5 pockets: 12, 35, 3, 26, 0, 32)
      let k = 0;
      if (i === 34) k = 0;
      if (i === 35) k = 1;
      if (i === 36) k = 2;
      if (i === 0) k = 3;
      if (i === 1) k = 4;
      const da = Math.PI / 5;
      const a1 = Math.PI / 2 + k * da;
      const a2 = a1 + da;
      const xo1 = X_L + R_out * Math.cos(a1);
      const yo1 = Y_C + R_out * Math.sin(a1);
      const xo2 = X_L + R_out * Math.cos(a2);
      const yo2 = Y_C + R_out * Math.sin(a2);
      const xi1 = X_L + R_in * Math.cos(a1);
      const yi1 = Y_C + R_in * Math.sin(a1);
      const xi2 = X_L + R_in * Math.cos(a2);
      const yi2 = Y_C + R_in * Math.sin(a2);
      d = `M ${xo1} ${yo1} A ${R_out} ${R_out} 0 0 1 ${xo2} ${yo2} L ${xi2} ${yi2} A ${R_in} ${R_in} 0 0 0 ${xi1} ${yi1} Z`;
      const am = (a1 + a2) / 2;
      const rm = (R_out + R_in) / 2;
      tx = X_L + rm * Math.cos(am);
      ty = Y_C + rm * Math.sin(am) + 4;
    }

    // Straight bet amount if bet directly on this number (type_id = num + 1)
    const straightBetTypeId = num + 1;
    const straightBetSum = activeBets.value
      .filter((b) => Number(b.type_id) === straightBetTypeId)
      .reduce((acc, b) => acc + (parseFloat(b.amount) || 0), 0);

    const isCovered = coveredNumbersSet.value.has(num);

    cells.push({
      num,
      d,
      tx,
      ty,
      type: getNumberType(num),
      isCovered,
      hasBet: straightBetSum > 0 || isCovered,
      chipAmount: straightBetSum > 0 ? formatChipLabel(straightBetSum) : null,
    });
  });

  return cells;
});
</script>

<style scoped>
.roulette-component {
  width: 100%;
}

.racetrack-wrapper {
}

.roulette-racetrack-v2 {
  position: relative;
}

/* .racetrack-svg {
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.4));
} */

/* ── ZONE INTERNE ── */
.svg-zone {
  fill: url(#sectorClothGrad);
  stroke: rgba(255, 255, 255, 0.25);
  stroke-width: 1.2px;
  transition: all 0.25s ease;
  cursor: default;
}

.svg-zone.--active {
  fill: url(#sectorClothGrad) !important;
  stroke: rgba(255, 255, 255, 0.5) !important;
  filter: brightness(1.25);
}

/* ── TESTI DELLE ZONE ── */
.svg-zone-text {
  fill: #ffffff;
  font-family: inherit;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  pointer-events: none;
}

.svg-zone-text.--badge {
  fill: #fcd34d;
}

/* ── NUMERI DELLA PISTA ── */
.svg-cell-group {
  cursor: default;
}

.svg-cell-path {
  stroke: rgba(255, 255, 255, 0.22);
  stroke-width: 0.85px;
}

.svg-cell-group.--red .svg-cell-path {
  fill: #b91c1c;
}

.svg-cell-group.--black .svg-cell-path {
  fill: #0f172a;
}

.svg-cell-group.--green .svg-cell-path {
  fill: #047857;
}

.svg-cell-text {
  fill: #ffffff;
  font-family: inherit;
  font-weight: 700;
  pointer-events: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.9);
}

.svg-cell-group.--highlighted .svg-cell-path {
  stroke: #ffffff !important;
  stroke-width: 1.6px !important;
  filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.85));
}

.svg-cell-group.--highlighted .svg-cell-text {
  fill: #ffffff;
  font-weight: 900;
}

/* ── WINNING EXTRACTED NUMBER RING ── */
.winning-ring-svg {
  filter: drop-shadow(0 0 5px rgba(250, 204, 21, 0.9));
}

/* ── CHIPS SVG (UNIFORM BLUE FOR ALL) ── */
.racetrack-chip {
  transition: transform 0.2s ease;
}

.chip-base {
  fill: #2563eb;
  stroke: #ffffff;
  stroke-width: 1.5px;
}

.chip-sector {
  fill: #2563eb;
}

.chip-ring {
  fill: none;
  stroke: rgba(255, 255, 255, 0.7);
  stroke-width: 1px;
  stroke-dasharray: 2, 2;
}

.chip-label {
  fill: #ffffff;
  font-size: 7px;
  font-weight: 800;
  font-family: inherit;
  letter-spacing: -0.02em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.9);
}
</style>
